"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _config = require("../../../config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var EditButton = function EditButton(props) {
  var openEdit = props.openEdit,
    product = props.product,
    children = props.children;
  var isProductSold = _config.SHOW_STATUS_OF_PRODUCT_SOLD_WHEN_QUANTITY_0 && product.quantity === 0 && product.status === "published";
  return !isProductSold && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _config.PRODUCTS_CREATION_TYPE === "dialog" ? children({
    onClick: openEdit(product)
  }) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: "no-underline",
    to: "/".concat(props.productCreationEndpoint || _config.PRODUCTS_CREATION_ENDPOINT, "/").concat(product.id)
  }, children()));
};
exports.EditButton = EditButton;